/** Centralized backend endpoint paths (relative to BASE_URL). */
export const ApiEndPoints = {
  // Auth
  access: {
    login: 'access/login',
    me: 'access/me',
  },

  // Roles & permissions
  role: 'access/role',
  permission: 'access/permission',
  rolePermission: 'access/role-permission',

  // Organizations
  organization: 'organisation/organization',
  organizationEcScope: 'organisation/organization-ec-scope',
  organizationEcScopeBulk: 'organisation/organization-ec-scope/bulk',
  organizationLevel: 'organisation/level',
  organizationLevelBulk: 'organisation/level/bulk',
  organizationHierarchyTemplate: 'organisation/hierarchy/template',
  organizationHierarchyUpload: 'organisation/hierarchy/upload',
  organizationNodeTree: 'organisation/node/tree',
  organizationNodeArea: 'organisation/node-area',

  // Territory (location hierarchy — loaded lazily, level by level)
  territory: {
    ecLevel: 'territory/ec-level',
    state: 'territory/state',
    parliament: 'territory/parliament',
    assembly: 'territory/assembly',
    gramPanchayat: 'territory/gram-panchayat',
    village: 'territory/village',
    psVillageMap: 'territory/ps-village-map',
    blockUlb: 'territory/block-ulb',
    ward: 'territory/ward',
  },
} as const;
